import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { AeroCloudService } from 'app/services/aero-cloud/aero-cloud.service';
import { CVANotificationService } from 'app/services/cva-notification/cva-notification.service';
import { LoginService } from 'app/services/login/login.service';
import { SpinnerService } from 'app/services/spinner/spinner.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'cva-standalone-aero-cloud-auth',
  standalone: true,
  imports: [],
  templateUrl: './aero-cloud-auth.component.html',
  styleUrl: './aero-cloud-auth.component.scss'
})
export class AeroCloudAuthComponent implements OnInit {
  errorMessage = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private _aeroCloudService: AeroCloudService,
    private _customLoginService: CustomLoginService,
    private _loginService: LoginService,
    private _spinner: SpinnerService,
    public _notification: CVANotificationService,
    public _router: Router,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this._aeroCloudService.sessionKey = decodeURIComponent(queryParams.cva_sessionKey);
      this._aeroCloudService.callBackUrl = decodeURIComponent(queryParams.cva_callbackURL);
      this._aeroCloudService.sessionId = decodeURIComponent(queryParams.cva_sessionGroup);
      sessionStorage.setItem('session_key', queryParams.cva_sessionKey);
      sessionStorage.setItem('callback_url', queryParams.cva_callbackURL);
      sessionStorage.setItem('cva_mode', queryParams.cva_mode);
      sessionStorage.setItem('session_id', queryParams.cva_sessionGroup)
      this._aeroCloudService.getContext().subscribe({
        next: (res) => {
          this._aeroCloudService.patientContextKey = res.clinicReferenceId + '-' + res.providerReferenceId + '-' + res.patientReferenceId;
          sessionStorage.setItem('patientContextKey', this._aeroCloudService.patientContextKey);
          this._aeroCloudService.context = res;
          sessionStorage.setItem('aeroCloudContext', JSON.stringify(res));
          this.authenticate(res.cvaUserId, res.cvaPassword);
        },
        error: () => {
          this.errorMessage = "Error occurred while fetching the context. Please try again later";
        }
      });
    });
  }

  authenticate(email, password) {
    this._spinner.show({ message: 'Authenticating' });
    this._customLoginService.login({
      email,
      password
    }).pipe(
      finalize(() => {
        this._spinner.hide();
      })
    ).subscribe({
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      next: (async (res: any) => {
        console.log("Login successful, redirecting to landing page");
        const redirectUrl = res.body?.redirectUrl;
        if (redirectUrl) {
          this._loginService.loggedIn$.next(true);
          window.location.href = redirectUrl;
        } else {
          this.errorMessage = "Error occurred while authenticating the user. Please try again later";
          this._loginService.loggedIn$.next(false);
        }
      }), error: () => {
        console.log("Login failed");
        this.errorMessage = "Error occurred while authenticating the user. Please try again later";
      }
    });
  }
}
